import { serviceRequest } from 'utils/http';
import { Service } from 'common/api';

export function getCurrentSiteEmployeeAPI() {
  return serviceRequest(() => Service.siteEmployeeControllerGetCurrentSiteEmployee());
}
